import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  subtext?: string;
  onClick?: () => void;
  scrollTo?: string;
  className?: string;
}
export function CTAButton({
  text,
  subtext,
  onClick,
  scrollTo,
  className = ''
}: CTAButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    if (scrollTo) {
      const el = document.getElementById(scrollTo);
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
        return;
      }
    }
    window.open('https://pay.hotmart.com/F104790430S?off=mhpya9ja', '_blank');
  };
  return <div className={`flex flex-col items-center ${className}`} data-id="element-12">
      <button onClick={handleClick} className="group relative inline-flex items-center justify-center px-8 py-4 text-lg md:text-xl font-bold text-white transition-all duration-300 bg-brand-coral rounded-full hover:bg-brand-coralDark hover:scale-105 hover:shadow-xl focus:outline-none focus:ring-4 focus:ring-brand-coral/50 animate-pulse-slow hover:animate-none" aria-label={text} data-id="element-13">
        <span className="mr-2" data-id="element-14">{text}</span>
        <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-15" />
      </button>
      {subtext && <p className="mt-3 text-sm text-brand-charcoal/70 flex items-center gap-1" data-id="element-16">
          <svg className="w-4 h-4 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-17">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-18" />
          </svg>
          {subtext}
        </p>}
    </div>;
}